import { render } from "./ViewsHomeTypeCategories.vue?vue&type=template&id=78ef3670"
import script from "./ViewsHomeTypeCategories.vue?vue&type=script&lang=js"
export * from "./ViewsHomeTypeCategories.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__